module.exports = __webpack_public_path__ + "img/navRecapBanner2024-pt.eb39459e.svg";